import React from "react";
import { Select } from "@radix-ui/themes";
import i18next from "i18next";

export const SelectDropdownFilter: React.FunctionComponent<{
  setState: any;
  state: any;
  optionsList: {
    name: string;
    value: string;
  }[];
  defaultSelected: string;
  hideDefault?: boolean;
}> = (props) => {
  return (
    <Select.Root
      defaultValue={props.defaultSelected}
      value={props.state}
      onValueChange={(e: any) => {
        props.setState(e);
      }}
    >
      <Select.Trigger />
      <Select.Content>
        <Select.Group>
          {props.optionsList &&
            props.optionsList.map((option) => {
              return (
                <Select.Item value={option.value} key={option.value}>
                  {i18next.t(`challenges.status.${option.value}`)}
                </Select.Item>
              );
            })}

          <Select.Group>
            {!props.optionsList && (
              <Select.Item value="error">Error</Select.Item>
            )}
          </Select.Group>
        </Select.Group>
      </Select.Content>
    </Select.Root>
  );
};
